<template>
  <v-container class="mt-4 px-5" fluid>
    <v-card class="shadowCard">
      <v-card-title primary-title class="text-subtitle-1">
        Métodos de pago fast 2026
        <v-spacer></v-spacer>
        <v-btn
          color="blue-grey"
          class="white--text"
          small
          tile
          @click="descargar"
        >
          Descargar
          <v-icon right dark>mdi-cloud-download</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <embed
          :src="visor"
          width="100%"
          :height="tamanioPantalla"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
  const NOMBRE_ARCHIVO = "OCT 26' Sistema de pagos Fast English 2026.pdf"

  export default {
    computed: {
      archivo() {
        return 'https://escuelakpi.club/imagenes-promociones/' + encodeURIComponent(NOMBRE_ARCHIVO)
      },

      visor() {
        return 'https://escuelakpi.club/viewer/web/viewer.html?file=' + encodeURIComponent(this.archivo)
      },

      tamanioPantalla() {
        return this.$vuetify.breakpoint.height - 185
      },
    },

    methods: {
      descargar() {
        window.open(this.archivo, '_blank')
      },
    },
  }
</script>
